import { ChatbotAskQuestionRequest } from 'it/primatoo/openapi/api/org/schemas/chatbot/ChatbotAskQuestionRequest';
import { ChatbotAskQuestionResponse } from 'it/primatoo/openapi/api/org/schemas/chatbot/ChatbotAskQuestionResponse';
import {
  ChatbotSendSectionReactionRequest
} from 'it/primatoo/openapi/api/org/schemas/chatbot/ChatbotSendSectionReactionRequest';
import { ChatbotSendReactionRequest } from 'it/primatoo/openapi/api/org/schemas/chatbot/ChatbotSendReactionRequest';
import { ChatbotGenericMessage } from './chatbot-generic-message';
import { ChatbotMessageType } from './chatbot-message-type';
import { Observable } from 'rxjs';

export const USER_CHATBOT = 'Primatoo Bot';

export class ChatbotMessages<E> {
  user?: string;
  timestamp!: number;
  messageType!: ChatbotMessageType;
  payload!: E;
  isCollapsed!: boolean;


  static fromChatbotMessage(payload: Observable<string>): ChatbotMessages<Observable<string>> {
    return {
      user: USER_CHATBOT,
      timestamp: Date.now(),
      messageType: ChatbotMessageType.Chatbot,
      payload: payload,
      isCollapsed: true
    };
  }

  static fromChatbotAskQuestionRequest(payload: ChatbotAskQuestionRequest, user: string): ChatbotMessages<ChatbotAskQuestionRequest> {
    return {
      user,
      timestamp: Date.now(),
      messageType: ChatbotMessageType.ChatbotAskQuestionRequest,
      payload: payload,
      isCollapsed: true
    };
  }

  static fromChatbotAskQuestionResponse(payload: ChatbotAskQuestionResponse, user: string): ChatbotMessages<ChatbotAskQuestionResponse> {
    return {
      user,
      timestamp: Date.now(),
      messageType: ChatbotMessageType.ChatbotAskQuestionResponse,
      payload: payload,
      isCollapsed: true
    };
  }

  static fromChatbotSendSectionReactionRequest(payload: ChatbotSendSectionReactionRequest, user: string): ChatbotMessages<ChatbotSendSectionReactionRequest> {
    return {
      user,
      timestamp: Date.now(),
      messageType: ChatbotMessageType.ChatbotSendSectionReactionRequest,
      payload: payload,
      isCollapsed: true
    };
  }

  static fromChatbotSendReactionRequest(payload: ChatbotSendReactionRequest, user: string): ChatbotMessages<ChatbotSendReactionRequest> {
    return {
      user,
      timestamp: Date.now(),
      messageType: ChatbotMessageType.ChatbotSendReactionRequest,
      payload: payload,
      isCollapsed: true
    };
  }

  static createGeneric(payload: ChatbotGenericMessage, user: string): ChatbotMessages<ChatbotGenericMessage> {
    return {
      user,
      timestamp: Date.now(),
      messageType: ChatbotMessageType.ChatbotGenericMessage,
      payload: payload,
      isCollapsed: true
    };
  }
}
